// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAC47LuFPcR2jNU4-9pYrk-VzBlUWE4LGc",
  authDomain: "pristinesmile-854f6.firebaseapp.com",
  projectId: "pristinesmile-854f6",
  storageBucket: "pristinesmile-854f6.firebasestorage.app",
  messagingSenderId: "839443905547",
  appId: "1:839443905547:web:18700ae308d2b3d86a9b0e",
  measurementId: "G-2CJHXMLV12"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// const analytics = getAnalytics(app);
export const db = getFirestore(app);